$(document).ready(function(){
    let btnGenerate = $('.practice-report__gener-doc');
    let allCheckbox = $('.uploaded-doc').find('.control__input');

    $('.control__input').on('click', function () {
        var somethingChecked = false;
        $(allCheckbox).each(function () {
            if ($(this).is(':checked')) {
                somethingChecked = true;
                btnGenerate.addClass('is-visible');
            }
        });

        if (!somethingChecked) {
            btnGenerate.removeClass('is-visible');
        }
    })
})

$(document).on('click', '.js-payment', function (event) {
    event.preventDefault();
    BX.showWait();
    BX.ajax({
        url: '/local/ajax/generatePayment.php',
        method: 'POST',
        data: {
            mcok: $(this).data('mcok'),
            pk: $(this).data('pk'),
            u: $(this).data('u'),
            practice: $(this).data('practice') ? 1 : 0,
        },
        dataType: 'json',
        onsuccess: function(result) {
            BX.closeWait();
            if (result.error) {
                alert(result.error);
            } else {
                window.location.href = result.filePath;
            }
        }
    });
})
